import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import breakpoints from '@repo/ui-components/breakpoints';
import styles from '@components/utils/styles';

const DownloadsList = () => (
  <Container>
    <li>
      <a
        href="https://www.sportdog.com/media/downloads/415-1139-11.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Get the Catalog
      </a>
    </li>
    <li>
      <Link to="/support">Download Manuals</Link>
    </li>
    <li>
      <a
        href="https://www.sportdog.com/media/downloads/SportDOG_Basic_Training_Manual_400-1131-1_web.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Basic Training Manual
      </a>
    </li>
  </Container>
);

const Container = styled.ul`
  margin: 0;
  padding: 0;

  li {
    font-size: 0.875rem;
    color: ${styles.colors.gray[400]};
    padding: 0.5rem 0;
    text-transform: uppercase;
    text-align: center;
    list-style: none;

    @media (min-width: ${breakpoints.md}) {
      text-align: left;
    }

    a {
      color: ${styles.colors.gray[400]};
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }
`;

export default DownloadsList;
